/* eslint-disable react/prop-types */
// DeleteTutorialModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import DeleteTutorialForm from '../forms/DeleteTutorialForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DeleteTutorialModal = ({ show, handleClose, currentPDF }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar Tutorial</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DeleteTutorialForm currentPDF={currentPDF} />
      </Modal.Body>
      <Modal.Footer>
        <style>
          {`
      @media (max-width: 767px) {
        .button-container > .btn {
          width: 100%;
          margin-bottom: 10px;
        }

        .button-container > :nth-child(1) {
          order: 1;
        }
        .button-container > :nth-child(2) {
          order: 2;
        }
      }
    `}
        </style>

        <div
          className="d-flex flex-column-reverse flex-md-row justify-content-end button-container"
          style={{ gap: '1rem', width: '100%' }}
        >
          <Button variant="secondary" onClick={handleClose}>
            <FontAwesomeIcon icon="fa-xmark" style={{ marginRight: 5 }} />
            Cerrar
          </Button>
          <Button variant="danger" onClick={handleClose}>
            <FontAwesomeIcon icon="trash-can" style={{ marginRight: 5 }} />
            Eliminar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTutorialModal;
